import {AfterViewInit, Directive, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ITdoFileHandle} from '../models/ui/i-tdo-file-handle';

@Directive({
  selector: '[appDragFileToBrowser]'
})
export class DragFileToBrowserDirective implements AfterViewInit {
  @Input() backgroundColor: string;
  @Input() dragEnabled: boolean = true;
  @Output() files: EventEmitter<ITdoFileHandle[]> = new EventEmitter();
  @Output() filesList = new EventEmitter<FileList>();

  @HostBinding('style.background') public background;

  constructor(private sanitizer: DomSanitizer) {

  }

  ngAfterViewInit(): void {
    this.background = this.backgroundColor;
  }

  @HostListener('dragover', ['$event']) public onDragOver(evt: DragEvent): void {
    if (!this.dragEnabled) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#999';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt: DragEvent): void {
    if (!this.dragEnabled) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    this.background = this.backgroundColor;
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent): void {
    if (!this.dragEnabled) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    this.background = this.backgroundColor;
    const files: ITdoFileHandle[] = [];
    this.filesList.emit(evt.dataTransfer.files);
    for (let i = 0; i < evt.dataTransfer.files.length; i++) {
      const file = evt.dataTransfer.files[i];
      const url = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
      files.push({
        file,
        url
      });
    }
    if (files.length > 0) {
      this.files.emit(files);
    }
  }
}
